module.exports = __webpack_public_path__ + "img/google.3ec228d3.svg";